import LiveChat from 'live_chat/scripts/live_chat'

$(function () {
  LiveChat.init()
})
